// Candidate Status Options
export const candidateStatusOptions = [
  'Resume Review',
  'Resume Rejected',
  'HR Screening',
  'HR Screening Rejected',
  'Ready to Pitch',
  'Applied for Job',
  'Interview Scheduled',
  'Interview Round 1',
  'Interview Round 2',
  'Interview Round 3',
  'Interview Round 4',
  'Interview Rejected',
  'HR Interview',
  'Offered',
  'Offer Rejected',
  'Offer Accepted',
  'Onboarding',
  'Onboarded',
  'Rejected'
];

// Job Status Options
export const jobStatusOptions = [
  'Draft',
  'In Review',
  'Ready to Pitch',
  'Open',
  'On Hold',
  'Candidate Applied',
  'Candidate Onboarding',
  'Onboarded',
  'Closed',
  'Cancelled',
  'Rejected'
];

// Resource/Vendor Status Options
export const resourceStatusOptions = [
  'Requested',
  'Application Received',
  'Under Review',
  'Vendor Shortlisted',
  'Interview Round 1',
  'Interview Round 2',
  'Interview Round 3',
  'Interview Round 4',
  'Selected',
  'Ready for Onboarding',
  'Onboarded',
  'Rejected'
];

// Rejection Reasons
export const rejectionReasons = [
  'Skill Mismatch',
  'Budget Issue',
  'Position Closed',
  'Candidate Declined',
  'Failed Interview',
  'Duplicate Profile',
  'Other'
];
export const currentLocations = [
  'Mumbai, Maharashtra',
  'Bangalore, Karnataka',
  'Hyderabad, Telangana',
  'Chennai, Tamil Nadu',
  'Pune, Maharashtra',
  'Delhi, Delhi',
  'Noida, Uttar Pradesh',
  'Gurugram, Haryana',
  'Kolkata, West Bengal',
  'Ahmedabad, Gujarat',
  'Other',
];

export const primarySkillOptions = [
  'JavaScript',
  'React',
  'Node.js',
  'Java',
  'Python',
  'Angular',
  'Vue.js',
  'C#',
  'PHP',
  'Data Science',
  'DevOps',
  'Salesforce',
  'AWS',
  'Azure',
  'Google Cloud',
];

export const secondarySkillOptions = [
  'Docker',
  'Kubernetes',
  'SQL',
  'NoSQL',
  'GraphQL',
  'REST APIs',
  'TypeScript',
  'Microservices',
  'CI/CD',
  'Machine Learning',
  'UI/UX',
  'SEO',
  'Testing',
  'Blockchain',
];

export const workTypeOptions = [
  'Full-time',
  'Part-time',
  'Contract',
  'Freelance',
  'Internship',
  'Project-based',
];

export const roleOptions = [
  'Software Engineer',
  '.NET Developer',
  'Java Developer',
  'Full Stack Developer',
  'Frontend Developer',
  'Backend Developer',
  'Java Backend Developer',
  'Python Developer',
  'MERN Stack Developer',
  'MEAN Stack Developer',
  'Data Engineer',
  'Data Scientist',
  'DevOps Engineer',
  'Cloud Architect',
  'QA Engineer',
  'Test Automation Engineer',
  'Technical Lead',
  'Solutions Architect',
  'Security Engineer',
  'Systems Administrator',
  'Network Engineer',
  'Mobile Developer',
  'UX/UI Designer',
  'Product Manager',
  'Business Analyst',
  'Database Administrator',
  'Scrum Master',
  'Other',
];

export const feedbackStatusOptions = [
  'Resume Review',
  'Resume Rejected',
  'HR Screening',
  'HR Screening Rejected',
  'Ready to Pitch',
  'Applied for Job',
  'Interview Scheduled',
  'Interview Round 1',
  'Interview Round 2',
  'Interview Round 3',
  'Interview Round 4',
  'Interview Rejected',
  'HR Interview',
  'Offered',
  'Offer Rejected',
  'Offer Accepted',
  'Onboarding',
  'Onboarded',
  'Rejected'
];

// Source Options - Common recruitment sources
export const sourceOptions = [
  'LinkedIn',
  'Indeed',
  'Naukri',
  'Internal Referral',
  'Job Portal',
  'Campus Recruitment',
  'Headhunter',
  'Direct Application',
  'Agency',
  'Social Media',
  'Other',
];

// COMMENTED OUT - Notice Period filter disabled
// Notice Period Options - Common notice periods
/*
export const noticePeriodOptions = [
  'Immediate',
  '15 Days',
  '30 Days',
  '45 Days',
  '60 Days',
  '90 Days',
  '3 Months',
  '6 Months',
  'Not specified',
];
*/
